import { Timer } from "lucide-react";
import { useCountdown, pad } from "@/hooks/use-countdown";

const Countdown = () => {
  const { hours, minutes, seconds } = useCountdown();

  const units = [
    { value: pad(hours), label: "horas", testid: "countdown-hours" },
    { value: pad(minutes), label: "min", testid: "countdown-minutes" },
    { value: pad(seconds), label: "seg", testid: "countdown-seconds" },
  ];

  return (
    <div data-testid="offer-countdown" className="mt-10">
      <p className="mb-3 flex items-center gap-2 font-mono-accent text-xs uppercase tracking-[0.22em] text-secondary/90">
        <Timer className="h-4 w-4" />
        Oferta de lançamento expira em
      </p>
      <div className="flex items-center gap-3">
        {units.map((unit, i) => (
          <div key={unit.label} className="flex items-center gap-3">
            <div className="flex flex-col items-center">
              <span
                data-testid={unit.testid}
                className="min-w-[3.5rem] rounded-xl border border-primary-foreground/15 bg-primary-foreground/10 px-3 py-2 text-center font-mono-accent text-3xl font-semibold tabular-nums text-secondary backdrop-blur-sm"
              >
                {unit.value}
              </span>
              <span className="mt-1.5 font-mono-accent text-[0.6rem] uppercase tracking-[0.2em] text-primary-foreground/60">
                {unit.label}
              </span>
            </div>
            {i < units.length - 1 && (
              <span className="-mt-5 font-mono-accent text-2xl text-primary-foreground/40">:</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Countdown;
